import React from 'react';
import { Button } from '@apia/theme';
import { TResponsiveTableRowState } from '../types';

const RowStatesRenderer = ({ state }: { state: TResponsiveTableRowState }) => {
  const { Icon } = state;
  return (
    <Button
      {...window.getVariant('inherit')}
      title={state.tooltip}
      className={`${state.className ?? 'state'}_icon state_icon`}
      onKeyDown={console.log}
    >
      <Icon
        sx={React.useMemo(
          () => ({
            color: state.color ?? '',
          }),
          [state.color],
        )}
      />
    </Button>
  );
};

export default React.memo(RowStatesRenderer);
